import React, { useEffect, useState } from "react";
import Header from "./Local components/Header";
import s from "./Team.module.scss";
import RolePermission from "./Local components/RolePermission";
import Table from "./Local components/Table";
import {
  PaginatedTeamResponse,
} from "../../../../libs/Utils/Types/Teams";
import { parseClientError, swrFetcher } from "../../../../libs/api/Endpoints";
import useSWR from "swr";
import { UseAuthToken } from "../../../../libs/api/userSession";
function Team() {
  
  const [teamUnauthorized, setTeamUnauthorized] = useState<boolean>(false);
  const token = UseAuthToken();

  const {
    
    error,
    mutate
  } = useSWR<PaginatedTeamResponse, any, any>(
    token ? ["api/admin/team/members", token] : null,
    swrFetcher,
    {
      revalidateOnFocus: true,
      shouldRetryOnError: false, // Disable retrying on errors
    }
  );

  useEffect(() => {
    if (error) {
      const e = parseClientError(error);

      if (e.statusCode === 403) {
        setTeamUnauthorized(true);
      }
    }
  }, [error]);
  return (
    <div className={s.wrapper}>
      <Header unauthorized={teamUnauthorized} mutate={mutate}/>
      <div className={s.main}>
        <Table />
        <RolePermission />
      </div>
    </div>
  );
}

export default Team;
